/* eslint-disable @typescript-eslint/no-unused-vars */
import authSvc from '@efex-services/auth/authSvc';
import { Button } from '@efexteam/components';
import RefreshIcon from '@mui/icons-material/Refresh';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import {
  FormControl,
  FormHelperText,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Typography,
} from '@mui/material';
import { aesEncryptCBC } from '@utils/crypt';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useApiCall } from 'use-api-call';

interface ConfirmPasswordProps {
  onValidPassword: () => void;
}

const ConfirmPassword = ({ onValidPassword }: ConfirmPasswordProps) => {
  const { t } = useTranslation();

  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const {
    data,
    invoke: verifyUserPassword,
    loading,
    error,
  } = useApiCall(() =>
    authSvc.verifyUserPassword({ password: aesEncryptCBC(password) })
  );

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    verifyUserPassword();
  };

  useEffect(() => {
    if (data?.authorization) {
      onValidPassword();
    }
  }, [data, onValidPassword]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <form onSubmit={handleSubmit}>
          <Typography>{t('verifyPassword')}</Typography>
          <FormControl className="w-full !my-3" variant="outlined">
            <InputLabel htmlFor="outlined-adornment-password">
              {t('password')}
            </InputLabel>
            <OutlinedInput
              id="outlined-adornment-password"
              type={showPassword ? 'text' : 'password'}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              }
              onChange={(e) => setPassword(e.target.value)}
              error={!!error}
              label={t('password')}
            />
            {!!error && (
              <FormHelperText error>
                {t('tfValidatePasswordError')}
              </FormHelperText>
            )}
          </FormControl>
          <div className="block text-right">
            <Button
              appearance="primary"
              disabled={password.length <= 0 || loading}
              startIcon={
                loading ? <RefreshIcon className="animate-spin" /> : null
              }
              className="!ml-auto"
              type="submit"
            >
              {t('verify')}
            </Button>
          </div>
        </form>
      </Grid>
    </Grid>
  );
};

export default ConfirmPassword;
